<div class="firmware-container">
	<div class="header">
		<button class="back-button" (click)="back()" [title]="'common.back' | translate">
			<img src="assets/icons/arrow-back.svg" width="24" height="24" [alt]="'common.back' | translate" />
		</button>
		<h2>{{ 'firmware.title' | translate }}</h2>
	</div>

	<div class="fw-form">
        <h2>{{ 'firmware.choose_model' | translate }}</h2>
        <div class="form-group">
            <select [(ngModel)]="version" name="version">
                <option value="rc">RelayController</option>
                <!-- <option value="other">Other controller</option>                     -->
            </select>
		</div>
		<div class="form-group">
            <esp-web-install-button
                manifest="https://fw.akpeisov.kz/rc/manifest.json"
                baud-rate="921600">
            </esp-web-install-button>
		</div>
	</div>
	<div class="form-actions">
		<button class="cancel-button" (click)="back()">{{ 'common.back' | translate }}</button>
	</div>
</div>
